/**
 * Conversion d'un nombre ou montant en toutes lettres en français (avec Dirhams / Centimes)
 */
export const nombreEnLettres = (num) => {
  if (num === null || num === undefined || num === '') return '';
  const n = parseFloat(num);
  if (isNaN(n) || n === 0) return 'Zéro Dirham';

  const unites = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf'];
  const dizaines = ['', 'dix', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante', 'quatre-vingt', 'quatre-vingt'];
  const particuliers = ['dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];

  const convertBloc = (val) => {
    let s = '';
    const c = Math.floor(val / 100);
    const r = val % 100;
    const d = Math.floor(r / 10);
    const u = r % 10;

    if (c > 0) {
      if (c === 1) s += 'cent ';
      else s += unites[c] + ' cent' + (r === 0 ? 's ' : ' ');
    }

    if (r >= 10 && r <= 19) {
      s += particuliers[r - 10] + ' ';
    } else if (r >= 70 && r <= 79) {
      s += 'soixante-' + (r === 71 ? 'et-onze' : particuliers[r - 70]) + ' ';
    } else if (r >= 90 && r <= 99) {
      s += 'quatre-vingt-' + particuliers[r - 90] + ' ';
    } else {
      if (d > 0) {
        if (d === 8 && u === 0) s += 'quatre-vingts ';
        else if (u === 1 && d !== 8) s += dizaines[d] + '-et-un ';
        else s += dizaines[d] + (u > 0 ? '-' : ' ');
      }
      if (u > 0 && d !== 7 && d !== 9) {
        s += unites[u] + ' ';
      }
    }
    return s.trim();
  };

  const entier = Math.floor(Math.abs(n));
  const centimes = Math.round((Math.abs(n) - entier) * 100);

  let parts = [];
  const millions = Math.floor(entier / 1000000);
  const milliers = Math.floor((entier % 1000000) / 1000);
  const reste = entier % 1000;

  if (millions > 0) {
    if (millions === 1) parts.push('un million');
    else parts.push(convertBloc(millions) + ' millions');
  }

  if (milliers > 0) {
    if (milliers === 1) parts.push('mille');
    else parts.push(convertBloc(milliers) + ' mille');
  }

  if (reste > 0 || parts.length === 0) {
    parts.push(convertBloc(reste));
  }

  let words = parts.join(' ').trim().split(/\s+/);
  let formatted = words.map(w => {
    if (w.includes('-')) {
      return w.split('-').map(sub => sub.charAt(0).toUpperCase() + sub.slice(1)).join('-');
    }
    return w.charAt(0).toUpperCase() + w.slice(1);
  }).join(' ');

  let result = formatted + ' Dirham' + (entier > 1 ? 's' : '');
  if (centimes > 0) {
    result += ' et ' + convertBloc(centimes) + ' Centime' + (centimes > 1 ? 's' : '');
  }
  return result;
};
